var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { Fragment, useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import useProcessInstances from '../../../hooks/useProcessInstances';
import { Chip, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { extractValueFromProcessObject, isFieldEditable, } from '../../../helpers/response';
import { editProcess_AC } from '../../../store/actions/process';
import { createSetActions, createUnsetActions } from '../../../helpers/request';
import { makeActionCall } from '../../../helpers/action';
import EditAdornment from '../../EditAdornment';
import { ExactaAPI } from '../../../api/exactaapi';
import NewRelatedProcessTable from '../../FormFields/NewRelatedProcessField/NewRelatedProcessTable';
var ContentContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var ControlledRelatedProcess = function (_a) {
    var modelAlias = _a.modelAlias, processObject = _a.processObject, alias = _a.alias, label = _a.label, relatedProcess = _a.relatedProcess, valueAlias = _a.valueAlias, maxInstances = _a.maxInstances;
    var oldIds = extractValueFromProcessObject(processObject, alias) || [];
    var _b = useState(), content = _b[0], setContent = _b[1];
    var dispatch = useDispatch();
    var processesList = useProcessInstances(modelAlias, oldIds);
    console.log({ processesList: processesList });
    useEffect(function () {
        var values = {};
        oldIds.forEach(function (id) {
            var _a;
            values[id] = {
                id: id,
                value: extractValueFromProcessObject(((_a = processesList) === null || _a === void 0 ? void 0 : _a[id]) || {}, valueAlias),
            };
        });
        setContent(values);
    }, [processObject, alias, processesList]);
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var _d = useState(false), editMode = _d[0], toggleEditMode = _d[1];
    var isEditModeEnabled = isFieldEditable(processObject, alias);
    var filterRows = relatedProcess.filterRows;
    var handleClickOpen = function () {
        if (editMode) {
            setOpen(true);
        }
    };
    var handleClose = function () {
        setOpen(false);
    };
    var handleReset = function () {
        setContent({});
    };
    var onSelect = function (value) {
        var _a;
        setContent(__assign(__assign({}, content), (_a = {}, _a[value.id] = value, _a)));
    };
    var onRemove = function (value) {
        var prevValue = content;
        delete prevValue[value.id];
        setContent(__assign({}, prevValue));
    };
    var enableSelection = function () {
        if (maxInstances === -1) {
            return true;
        }
        else if (content) {
            return Object.keys(content).length < maxInstances;
        }
        return true;
    };
    console.log({ content: content, oldIds: oldIds });
    var updateToDb = function (body) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, makeActionCall(dispatch, editProcess_AC, [body])];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var handleSave = function () {
        var _a, _b;
        var exactaApi = ExactaAPI.getInstance();
        var newIds = Object.keys(content);
        var unset = oldIds.filter(function (id) { return !newIds.includes(id); });
        var set = newIds.filter(function (id) { return !oldIds.includes(id); });
        var unsetActions = createUnsetActions((_a = {},
            _a[alias] = { type: 'relatedProcessMultiple', values: unset },
            _a));
        var setActions = createSetActions((_b = {},
            _b[alias] = { type: 'relatedProcessMultiple', values: set },
            _b));
        var totalActions = __spreadArrays(unsetActions, setActions);
        if (totalActions.length > 0) {
            var body = {
                id: processObject.id,
                version: exactaApi.getApiVersion(),
                subscribe: false,
                actions: __spreadArrays(unsetActions, setActions),
            };
            updateToDb(body);
        }
        console.log({ set: set, unset: unset });
        toggleEditMode(function (prevValue) { return !prevValue; });
        handleClose();
    };
    var handleEditModeChange = function () {
        toggleEditMode(function (prevValue) { return !prevValue; });
    };
    return (React.createElement(Fragment, null,
        React.createElement(ContentContainer, null,
            editMode ? (React.createElement(TextField, { type: 'text', name: alias, label: label, value: content
                    ? Object.values(content)
                        .map(function (entry) { return entry.value; })
                        .join(', ')
                    : '', variant: "outlined", fullWidth: true, onClick: handleClickOpen, InputProps: {
                    readOnly: !editMode,
                    endAdornment: (React.createElement(IconButton, { onClick: handleClickOpen },
                        React.createElement(Icon, null, "search"))),
                } })) : (React.createElement("div", null,
                React.createElement(Typography, { variant: "subtitle1" }, label),
                content &&
                    Object.values(content)
                        .map(function (entry) { return entry.value; })
                        .map(function (val, index) {
                        return React.createElement(Chip, { key: index, label: val });
                    }))),
            isEditModeEnabled && (React.createElement(EditAdornment, { editMode: editMode, handleSave: handleSave, handleClose: handleEditModeChange, handleEditModeChange: handleEditModeChange, disabled: false }))),
        React.createElement(Dialog, { fullWidth: true, maxWidth: "lg", open: open, onClose: handleClose, scroll: 'paper', disableBackdropClick: true, disableEscapeKeyDown: true, "aria-labelledby": "scroll-dialog-title", "aria-describedby": "scroll-dialog-description" },
            React.createElement(DialogContent, { dividers: true }, content && (React.createElement(NewRelatedProcessTable, { onSelect: onSelect, onRemove: onRemove, value: content || {}, enableSelect: enableSelection(), filterRows: filterRows, tableDef: relatedProcess.tableDef, modelAlias: relatedProcess.modelAlias, title: relatedProcess.title, maxInstances: maxInstances }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: handleReset, color: "primary" }, "Reset"),
                React.createElement(Button, { onClick: handleClose, color: "primary" }, "Close")))));
};
export default ControlledRelatedProcess;
var templateObject_1;
//# sourceMappingURL=index.js.map